class Elearning {

    constructor() {
        this.step = 1;
        this.step_max = 1;

        this.getStepMax();
    }

    getStepMax() {
        var steps = $('.step').length;
        this.step_max = steps;
    }

    updateStep() {
        $('.value-step').html( this.step );

        // Change visible step
        $('.step').hide();
        $('#step-' + this.step).show();

        // Change question progress
        $(".module__header__steps li").removeClass('done');
        var question = $('#step-' + this.step).data('question');
        $(".module__header__steps li").each( function (index) {
            index += 1;
            if(index < question) {
                $(this).addClass("done");
            }
        });

        // Don't show question progress when no question is present
        if(question === undefined) {
            $('.module__header__steps').hide();
        } else {
            $('.module__header__steps').show();
        }

        // Show or don't show previous button when on first or last step
        if( this.step === 1 ) {
            $('.button--nav-prev').hide();
        } else {
            $('.button--nav-prev').show();
        }

        // Scroll module up
        $('html').scrollTop(0);
        $('.module__wrapper').scrollTop(0);
    }

    nextStep() {
        if(this.step !== this.step_max) {
            this.step = this.step + 1;
            this.updateStep();
        } else if(this.step >= this.step_max) {
            this.calculateResults();
        }
    }

    previousStep() {
        if(this.step !== 1) {
            this.step = this.step - 1;
            this.updateStep();
        } 
    }

    calculateResults() {
        // Hide other steps and navigation
        $('.step').hide();
        $('.button--nav-prev').hide();
        $('.button--nav-next').hide();
        $('.button--nav-finish').show();

        // Hide all answers in overview
        $('.overview .block__answer--false').hide();

        // Calculate results
        var status = 1;
        $( ".step[data-question]" ).each(function( index ) {
            var question = index + 1;
            var answer = $('input[name="question[' + question + ']"]:checked');
            var answerType = answer.parent('label').data('answer-type');

            // Show false answers again
            if(answerType !== 1) {
                // False answer
                status = 0;
                $('#answer_' + index + '_' + answer.val()).show();
            }
        });

        // Show overview or done step
        if( status == 0) {
            $('.overview').show();
        } else {
            $('.done').show();
        }
        
        // Show all steps as done
        $('.module__header__steps li').addClass("done");
    }

}
